import React from "react"

const racedata = [
    {
        "Date": "30-Dec",
        "Race/Ethnicity": "White, non-Hispanic",
        "All Cases": 127565,
        "Ever Hospitaltized": 8222,
        "Deaths": 9255
    },
    {
        "Date": "30-Dec",
        "Race/Ethnicity": "Black or African American, non-Hispanic",
        "All Cases": 23858,
        "Ever Hospitaltized": 1678,
        "Deaths": 892
    },
    {
        "Date": "30-Dec",
        "Race/Ethnicity": "Hispanic",
        "All Cases": 82601,
        "Ever Hospitaltized": 2466,
        "Deaths": 901
    },
    {
        "Date": "30-Dec",
        "Race/Ethnicity": "Asian, non-Hispanic",
        "All Cases": 9105,
        "Ever Hospitaltized": 566,
        "Deaths": 309
    },
    {
        "Date": "30-Dec",
        "Race/Ethnicity": "Other race, non-Hispanic",
        "All Cases": 27187,
        "Ever Hospitaltized": 1471,
        "Deaths": 903
    },
    {
        "Date": "30-Dec",
        "Race/Ethnicity": "Unknown, missing, or refused",
        "All Cases": 97184,
        "Ever Hospitaltized": 1677,
        "Deaths": 62
    },
    {
        "Date": "30-Dec",
        "Race/Ethnicity": "Native Hawaiian/ Pacific Islander, non-Hispanic",
        "All Cases": 107,
        "Ever Hospitaltized": 7,
        "Deaths": 5
    },
    {
        "Date": "30-Dec",
        "Race/Ethnicity": "American Indian/Alaskan Native, non-Hispanic",
        "All Cases": 311,
        "Ever Hospitaltized": 11,
        "Deaths": 11
    },
    {
        "Date": "20-Jan",
        "Race/Ethnicity": "White, non-Hispanic",
        "All Cases": 173346,
        "Ever Hospitaltized": 9131,
        "Deaths": 10331
    },
    {
        "Date": "20-Jan",
        "Race/Ethnicity": "Black or African American, non-Hispanic",
        "All Cases": 29226,
        "Ever Hospitaltized": 1768,
        "Deaths": 950
    },
    {
        "Date": "20-Jan",
        "Race/Ethnicity": "Hispanic",
        "All Cases": 104573,
        "Ever Hospitaltized": 2685,
        "Deaths": 1045
    },
    {
        "Date": "20-Jan",
        "Race/Ethnicity": "Asian, non-Hispanic",
        "All Cases": 12410,
        "Ever Hospitaltized": 614,
        "Deaths": 346
    },
    {
        "Date": "20-Jan",
        "Race/Ethnicity": "Other race, non-Hispanic",
        "All Cases": 36536,
        "Ever Hospitaltized": 1625,
        "Deaths": 1070
    },
    {
        "Date": "20-Jan",
        "Race/Ethnicity": "Unknown, missing, or refused",
        "All Cases": 124416,
        "Ever Hospitaltized": 1715,
        "Deaths": 71
    },
    {
        "Date": "20-Jan",
        "Race/Ethnicity": "Native Hawaiian/ Pacific Islander, non-Hispanic",
        "All Cases": 125,
        "Ever Hospitaltized": 7,
        "Deaths": 5
    },
    {
        "Date": "20-Jan",
        "Race/Ethnicity": "American Indian/Alaskan Native, non-Hispanic",
        "All Cases": 408,
        "Ever Hospitaltized": 11,
        "Deaths": 11
    }
]

export default racedata;
